import { IOrderConfirmationState } from './IOrderConfirmationState';

const initialState: IOrderConfirmationState = {
  data: null,
  loading: true,
  error: '',
};

const ordersConfirmationReducer = (state: any = initialState, action: any): IOrderConfirmationState => {
  switch (action.type) {
    case 'GET_ORDER_CONFIRMATION_REQUEST': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'GET_ORDER_CONFIRMATION_RESPONSE': {
      return {
        data: action.response,
        loading: false,
        error: null,
      };
    }
    case 'GET_ORDER_CONFIRMATION_ERROR': {
      return {
        data: null,
        loading: false,
        error: 'An error has occured',
      };
    }
    case 'CLEAR_ORDER_CONFIRMATION_CONTENTS': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default ordersConfirmationReducer;
